import thunkMiddleware from 'redux-thunk';

import { createStore, applyMiddleware, compose } from 'redux';

import rootReducer from './reducers';

const middlewares = [thunkMiddleware];

if (__DEV__) {
	// so that redux-logger doesn't get bundled up
	const loggerMiddleware = require('redux-logger')({ collapsed: true });
	middlewares.push(loggerMiddleware);
}

// let initialState = null;

let store = null;

if (__DEV__) {
	store = createStore(
		rootReducer,
		compose(
			applyMiddleware(...middlewares),
			window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
		)
	);
} else {
	store = createStore(rootReducer, applyMiddleware(...middlewares));
}

export default store;
